import { TournamentTypeAbstract } from "./TournamentTypeAbstract";

export class TournamentTypeRebuy extends TournamentTypeAbstract {
}
